import { getLabel } from "../../Util/EpollParser";
import { dataFetchError } from "../../Util/Messages";
import api from "../../api/api";
import * as actionTypes from "./actionTypes";

// export const SignUpStart = (name ,email , password )=> {

//     return dispatch => {
//         dispatch(LoadingSetter())
//          api.post('/user/create' , {"name":name ,"email":email , "password":password } )
//         .then(

//             response =>{
//                document.location.replace('/ComfirmYourAcount')
//             }
//         )
//         .catch (
//             err => {
//                 dispatch(ErrorSetter(err , 'SignUp'))
//                 dispatch(ClearLoading());
//             }
//         )
//     }
// }
// export const SignInInit = () => {
//     return {
//         type : actionTypes.SIGNIN_INIT
//     }
// }
const questionMapper = (
  question,
  questionTypes,
  questionFlags,
  parentQuestion
) => {
  let types = [];
  let flags = [];
  let allFlags = [];
  let optionsHasFlag = false;
  questionTypes.forEach((type) => {
    if (type.epollQuestionId == question.id && !type.epollAnswerId) {
      types = type.questionTypes;
    }
  });
  questionFlags.forEach((flag) => {
    if (flag.epollQuestionId == question.id && !flag.epollAnswerId) {
      flags = flag.flags;
    }
    if (flag.epollQuestionId == question.id) {
      allFlags = [...allFlags, ...flag.flags];
    }
    if (flag.epollQuestionId == question.id && flag.epollAnswerId) {
      optionsHasFlag = true;
    }
  });
  let children = [];
  if (Array.isArray(question.questions)) {
    return question.questions.map((subQuestion) => {
      return questionMapper(
        subQuestion,
        questionTypes,
        questionFlags,
        question
      );
    });
  } else if (Array.isArray(question.options)) {
    if (question.field_type === "multitext") {
      return question.options.map((subQuestion) => {
        return questionMapper(
          subQuestion,
          questionTypes,
          questionFlags,
          question
        );
      });
    }
    question.options.forEach((option) => {
      if (option.label) {
        let optionFlags = [];
        let optionTypes = [];
        questionTypes.forEach((type) => {
          if (type.epollAnswerId == option.id) {
            optionTypes = type.questionTypes;
          }
        });
        questionFlags.forEach((flag) => {
          if (flag.epollAnswerId == option.id) {
            optionFlags = flag.flags;
          }
        });
        children.push({
          id: option.id,
          key: option.id,
          title: getLabel(option),
          anwser_id: question.id,
          types: optionTypes,
          flags: optionFlags,
          isOption: true,
        });
      }
    });
  }
  return {
    title: parentQuestion
      ? getLabel(parentQuestion) + " - " + getLabel(question)
      : getLabel(question),
    types,
    flags,
    id: question.id,
    key: question.id,
    question_type: parentQuestion
      ? parentQuestion.field_type
      : question.field_type,
    children: children.length > 0 ? children : null,
    allFlags,
    optionsHasFlag,
  };
};
export async function getQuestions(epollFormId = "41744") {
  console.log(epollFormId);
  const res = await api.get("/question/formdto/" + epollFormId);
  const data = await [...res.data.formDto]
    .map((question) => {
      const questionTypes = res.data.hasQuestionTypes;
      const questionFlags = res.data.questionToFlags;
      return questionMapper(question, questionTypes, questionFlags);
    })
    .flat(1);
  // console.log(data)
  const questionTypes = await res.data.questionTypes;
  return await { data, questionTypes };
}

export const getDatabase = (epollFormId = "41744") => {
  return (dispatch) => {
    dispatch(LoadingSetter());
    api
      .get("/flags", { params: { all: true }})
      .then((res) => {
        const data = Array.isArray(res.data.data)
          ? res.data.data.sort((a, b) => {
              const ADate = new Date(a.createdAt);
              const BDate = new Date(b.createdAt);
              return BDate - ADate;
            })
          : res.data.data;
        dispatch(getDatabaseSuccess(data));
        dispatch(ClearLoading());
        dispatch(ClearError());
      })
      .catch(() => {
        dataFetchError();
        ClearLoading();
      });
    api
      .get("/skills")
      .then((res) => {
        const data = Array.isArray(res.data.data)
          ? res.data.data.sort((a, b) => {
              const ADate = new Date(a.createdAt);
              const BDate = new Date(b.createdAt);
              return BDate - ADate;
            })
          : res.data.data;
        dispatch(getDatabaseSuccess(null, data));
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
        dataFetchError();
      });
    api
      .get("/ways", {
        params: {
          page: 1,
          pageSize: 10000,
        },
      })
      .then((res) => {
        dispatch(getDatabaseSuccess(null, null, res.data.data));
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
        dataFetchError();
      });

    if (epollFormId) {
      getQuestions(epollFormId)
        .then((res) => {
          dispatch(
            getDatabaseSuccess(null, null, null, res.data, res.questionTypes)
          );

          ClearLoading();
        })
        .catch((err) => {
          // console.log(err)
          ClearLoading();
          dataFetchError();
        });
    }
  };
};

export const getDatabaseSuccess = (
  flags,
  skills,
  ways,
  questions,
  questionTypes
) => {
  return {
    type: actionTypes.GET_DATABASE_SSUCCESS,
    flags,
    skills,
    ways,
    questions,
    questionTypes,
  };
};
export const SignInStart = (username, password) => {
  return (dispatch) => {
    dispatch(LoadingSetter());
    api
      .post("/auth/local", { identifier: username, password: password })
      .then((response) => {
        const jwt = response.data.jwt;
        dispatch(SignInSuccess(jwt));
        dispatch(StartGetUserData(jwt));
        dispatch(ClearError());
        localStorage.setItem("token", jwt);
        window.location.reload();
      })
      .catch((error) => {
        dispatch(ErrorSetter(error, "SignIn"));
      });
  };
};

export const SignInSuccess = (token) => {
  return {
    type: actionTypes.SIGNIN_SUCCESS,
    token: token,
  };
};
export const StartGetUserData = (token) => {
  return (dispatch) => {
    api
      .get("/users/me", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        dispatch(GetUserDataSuccess(res.data));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data) {
            const ErrorMessage = error.response.data.error.name;
            if (
              ErrorMessage === "UnauthorizedError" ||
              ErrorMessage === "Invalid token."
            ) {
              dispatch(Logout());
            }
          }
        }
      });
  };
};

const GetUserDataSuccess = (userData) => {
  return {
    type: actionTypes.GET_USER_DATA_SUCCESS,
    userData: userData,
  };
};

export const StartChangeUserAvatar = (avatar, token) => {
  return (dispatch) => {
    dispatch(LoadingSetter());
    const fd = new FormData();
    fd.append("avatar", avatar);
    api
      .patch("/user/me", fd, {
        headers: {
          Authorization: "Token " + token,
          "content-type": "multipart/form-data",
        },
        onUploadProgress: (ProgressEvent) => {
          // console.log(Math.round(ProgressEvent.loaded / ProgressEvent.total * 100));
        },
      })
      .then((res) => {
        dispatch(GetUserDataSuccess(res.data));
        document.location.reload();
      })
      .catch((err) => {
        dispatch(ErrorSetter(err, "ChangeAvatar"));
      });
  };
};
export const StartChangeUserData = (name, gender, birthDate, token) => {
  return (dispatch) => {
    dispatch(LoadingSetter());
    api
      .patch(
        "/user/me",
        {
          name: name,
          gender: gender,
          birth_date: birthDate,
        },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      )
      .then((res) => {
        dispatch(GetUserDataSuccess(res.data));
      })
      .catch((err) => {
        dispatch(ErrorSetter(err, "ChangeUserData"));
      });
  };
};
export const StartChangeUserPassword = (LastPassword, NewPassword, token) => {
  return (dispatch) => {
    dispatch(LoadingSetter());
    api
      .post(
        "/user/me/changepass",
        {
          old_pass: LastPassword,
          new_pass: NewPassword,
        },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      )
      .then((res) => {
        dispatch(ClearLoading());
      })
      .catch((err) => {
        dispatch(ErrorSetter(err, "ChangePassword"));
      });
  };
};
export const LoadingSetter = () => {
  return {
    type: actionTypes.LOADING_SETTER,
  };
};
export const ClearLoading = () => {
  return {
    type: actionTypes.CLEAR_LOADING,
  };
};
export const ErrorSetter = (error, ErrorType) => {
  return {
    type: actionTypes.ERROR_SETTER,
    error: error,
    ErrorType: ErrorType,
  };
};
export const ClearError = () => {
  return {
    type: actionTypes.CLEAR_ERROR,
  };
};
export const Logout = () => {
  return {
    type: actionTypes.LOGOUT,
  };
};
export const TokenSetter = (token) => {
  return {
    type: actionTypes.TOKEN_SETTER,
    token,
  };
};
